<template>
  <BaseDialog
    :title="$t('survey.editMembers')"
    :is-open="isOpen"
    type="responsive"
    :align-dismiss-button-right="true"
    @close="closeDialog"
  >
    <SurveyMembersForm
      v-model:feedback-sender-ids="formData.feedbackSenderIds"
      :members-error="errors.get('feedbackSenderIds')"
    />
    <template #confirm>
      <BaseTextButton color="filled" :disabled="isSaving || !isFormValid" @click="saveSurveyEdits">
        {{ $t('common.save') }}
      </BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton color="text" :disabled="isSaving" @click="closeDialog">
        {{ $t('common.cancel') }}
      </BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script setup lang="ts">
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import SurveyMembersForm from '@/modules/start-survey/components/SurveyMembersForm.vue'
  import { useEditCoachSurvey } from '../composables/use-edit-coach-survey'
  import type { CoachSurvey } from '../composables/use-coach-survey'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { computed, watch } from 'vue'

  interface Props {
    isOpen: boolean
    survey: CoachSurvey
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'close-dialog'): void
    (e: 'survey-updated'): void
  }>()

  const closeDialog = () => {
    emit('close-dialog')
    resetForm()
  }

  watch(
    () => props.isOpen,
    () => {
      resetForm()
    },
  )

  const { isFormValid, saveSurveyEdits, resetForm, formData, errors, isSaving } =
    useEditCoachSurvey(
      computed(() => props.survey),
      () => {
        emit('survey-updated')
        closeDialog()
      },
    )
</script>
